export const isTestRealm = () => {
  return localStorage.getItem("test_realm") === "true";
};

export const setTestRealm = (value: boolean) => {
  if (value) {
    localStorage.setItem("test_realm", "true");
  } else {
    localStorage.removeItem("test_realm");
  }
};

export const getCurrentCountry = (): CountryCodes => {
  try {
    if (isTestRealm()) {
      return "KZ";
    }
  } catch {}
  return "NL";
};

export const COUNTRY_LABELS = {
  NL: "Netherlands",
  KZ: "Kazakhstan",
};

export type CountryCodes = "NL" | "KZ";

export const COUNTRY_OPTIONS = Object.fromEntries(
  Object.entries(COUNTRY_LABELS).map(([k, v]) => [k, { value: k, label: v }]),
) as Record<CountryCodes, { value: CountryCodes; label: string }>;

export const listSupportedCountries = (): CountryCodes[] => {
  return isTestRealm() ? ["NL", "KZ"] : ["NL"];
};
